import DefaultUsers from "src/components/feature/ImplementingAgency";

const ImplementingAgency = () => {
  return <DefaultUsers />;
};

export default ImplementingAgency;
